import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_HR.json';
import recipes from './COOKING_RECIPES_HR.json';
import videos from './COOKING_VIDEOS_HR.json';

export const COOKING_DATA_HR: ServiceData = {
  articles,
  recipes,
  videos,
};
